import { DefaultButton, Pivot, PivotItem, PrimaryButton, Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import SelectCobrandsForm from '../../../CoBrandSettings/HubSettings/Forms/SelectCobrandsForm';
import ShowCobrandList from '../../../CoBrandSettings/HubSettings/ShowCobrandList';
import SettingsTable from '../Components/SettingsTable';
import FeatureSummary from "../../../../Util/FeatureSummary";


const newCoBrandSettingsObject = {
    client: '',
    cobrandTag: '',
    cobrand: '',
};

const CourseCobrandSettingsPage = () => {
    const [selectedKey, setSelectedKey] = useState("0");
    const [cobrandList, setCobrandList] = useState([]);
    const [totalToUpdate, setTotalToUpdate] = useState(0);

    const handleLinkClick = (item) => {
        const itemKey = item.props.itemKey;
        setSelectedKey(itemKey);
    };
    const handlePrevClick = () => setSelectedKey("0");
    const handleNextClick = () => setSelectedKey("1");

    return (
        <Formik
            initialValues={
                newCoBrandSettingsObject
            }
            isInitialValid={false}
        >
            {({ values }) => {
                return (
                    <Form style={{ maxWidth: '1300px' }}>

                        <div style={{ width: '100%' }} className="mt-1">
                            <Pivot selectedKey={selectedKey} onLinkClick={handleLinkClick}>
                                <PivotItem headerText="Select Cobrand" itemKey={'0'}>
                                    <SelectCobrandsForm />
                                </PivotItem>
                                <PivotItem headerText="Update Settings" itemKey={'1'}>
                                    <SettingsTable cobrandIdList={cobrandList}/>
                                </PivotItem>
                            </Pivot>
                            <hr />
                            <div style={{ display: 'flex', justifyContent: 'space-between' }} className="mt-1">
                                    {selectedKey === "0"? (
                                        <div />
                                    ) : (
                                        <DefaultButton text="Prev" onClick={handlePrevClick} />
                                    )}
                                    {selectedKey === "1" ? (
                                        <div />
                                    ) : (
                                        <PrimaryButton text="Next" onClick={handleNextClick} />
                                    )}
                                </div>
                        </div>

                        {selectedKey === "0" && (
                            <>
                            <ShowCobrandList
                                clients={values.client}
                                tags={values.cobrandTag}
                                cobrands={values.cobrand}
                                setParentCobrandList={setCobrandList}
                                setTotalToUpdate={setTotalToUpdate}
                            />
                            <FeatureSummary
                                label="About Course Cobrand Settings"
                                summary="This section allows admins update course settings for cobrands. First, choose specific clients, tags, and cobrands to manage their course-related configurations."
                                imageUrlPath='courses-all2'
                            />
                            </>
                        )}
                       
                    </Form>
                );
            }}
        </Formik>
    );
};

export default CourseCobrandSettingsPage;
